export function set_retailer(retailer_data) {
    return {
        type: "@retailers/SETRETAILER",
        payload: retailer_data
    };
}
